import React from 'react';
import { Avatar } from '@hose/eui';
import { FilledGeneralMember } from '@hose/eui-icons';
import cx from 'classnames';
import styles from './xs-avatar.module.less';
export var XSAvatar = function (_a) {
    var _b;
    var avatar = _a.avatar;
    return (React.createElement(Avatar, { className: cx(styles.avatar, styles['xs-avatar'], (_b = {}, _b[styles['default-avatar']] = !avatar, _b)), src: avatar || React.createElement(FilledGeneralMember, { fontSize: 12 }) }));
};
